import { render, staticRenderFns } from "./TraderShield.vue?vue&type=template&id=50f45603&scoped=true"
import script from "./TraderShield.vue?vue&type=script&lang=ts&setup=true"
export * from "./TraderShield.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TraderShield.vue?vue&type=style&index=0&id=50f45603&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f45603",
  null
  
)

export default component.exports